// Polyfills for the recent JS proposals pdfjs-dist >=5.x relies on but
// most browsers don't yet ship. Must run before pdfjs initializes, so
// import this at the top of every entry point (main thread + worker)
// that loads pdfjs.
//
// PERFECTOMY-376: TypeError "this[#methodPromises].getOrInsertComputed
// is not a function" — Map.prototype.getOrInsertComputed is part of the
// TC39 "Upsert" proposal (Stage 2) and is missing on Chrome <144, all
// Firefox, and all Safari as of 2026.

if (typeof (Promise as unknown as { withResolvers?: unknown }).withResolvers !== "function") {
    (Promise as unknown as { withResolvers: () => unknown }).withResolvers = function withResolvers<T>(this: PromiseConstructor) {
        let resolve!: (value: T | PromiseLike<T>) => void;
        let reject!: (reason?: unknown) => void;
        const promise = new this<T>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return {promise, resolve, reject};
    };
}

interface MapWithUpsert<K, V> extends Map<K, V> {
    getOrInsert?: (key: K, defaultValue: V) => V;
    getOrInsertComputed?: (key: K, factory: (key: K) => V) => V;
}

if (typeof (Map.prototype as MapWithUpsert<unknown, unknown>).getOrInsert !== "function") {
    Object.defineProperty(Map.prototype, "getOrInsert", {
        configurable: true,
        writable: true,
        value: function <K, V>(this: Map<K, V>, key: K, defaultValue: V): V {
            if (this.has(key)) return this.get(key) as V;
            this.set(key, defaultValue);
            return defaultValue;
        },
    });
}

if (typeof (Map.prototype as MapWithUpsert<unknown, unknown>).getOrInsertComputed !== "function") {
    Object.defineProperty(Map.prototype, "getOrInsertComputed", {
        configurable: true,
        writable: true,
        value: function <K, V>(this: Map<K, V>, key: K, factory: (key: K) => V): V {
            if (this.has(key)) return this.get(key) as V;
            const value = factory(key);
            this.set(key, value);
            return value;
        },
    });
}

export {};
